import logo from '@/assets/hiredcoach-logo.svg';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { Copy, Mail } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

export const ContactContent: React.FC = () => {
  const { user } = useAuth();

  const buildMailto = (
    local: string,
    domain: string,
    tld: string,
    subject: string,
  ) => {
    const address = [local, '@', domain, '.', tld].join('');
    const bodyPrefix = user?.id ? `User ID: ${user.id}\n\n` : '';
    const body = `${bodyPrefix}`;
    const uri = `mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    return uri;
  };

  const handleSupportClick = () => {
    window.location.href = buildMailto('support', 'hiredcoach', 'ai', 'Support request');
  };

  const handleFounderClick = () => {
    window.location.href = buildMailto('keith', 'hiredcoach', 'ai', 'Message for the Founder');
  };

  const copyToClipboard = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success('Email copied to clipboard');
    } catch (e) {
      toast.error('Failed to copy email');
    }
  };

  const copySupportEmail = () => copyToClipboard(['support', '@', 'hiredcoach', '.', 'ai'].join(''));
  const copyFounderEmail = () => copyToClipboard(['keith', '@', 'hiredcoach', '.', 'ai'].join(''));

  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex flex-col items-center text-center mb-8">
        <img src={logo} alt="HiredCoach" className="w-20 h-20 mb-3" />
        <h1 className="text-3xl font-bold text-gray-800">
          Contact <span className="text-[#4f9ecb]">Hired</span><span className="text-[#334763]">Coach</span>
        </h1>
        <p className="text-gray-600 mt-3 max-w-2xl">
          If you have any questions, feel free to reach out to our support team.
          We strive to respond respond within 1 day.
        </p>
      </div>

      <Card className="bg-white border-gray-200 shadow-sm">
        <CardContent className="p-6">
          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Support</h2>
              <p className="text-gray-700 mt-1">
                For help with your account, billing, or product questions, email our
                <button
                  type="button"
                  onClick={copySupportEmail}
                  className="ml-1 font-medium underline decoration-dotted text-[#334763] hover:text-[#4f9ecb]"
                  title="Copy support email"
                  aria-label="Copy support email"
                >
                  support
                </button>
                <button
                  type="button"
                  onClick={copySupportEmail}
                  className="ml-1 inline-flex items-center justify-center align-[-2px] text-gray-500 hover:text-gray-700"
                  aria-label="Copy support email"
                  title="Copy support email"
                >
                  <Copy className="h-4 w-4" />
                </button>
                {' '}team.
              </p>
              <div className="mt-4 flex justify-center">
                <Button onClick={handleSupportClick} style={{ backgroundColor: '#4f9ecb' }} className="text-white">
                  <Mail className="mr-2 h-4 w-4" /> Email Support
                </Button>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-6">
              <h2 className="text-xl font-semibold text-gray-900">Talk to the Founder</h2>
              <p className="text-gray-700 mt-1">
                Have feedback, ideas, or just want to reach out to our founder? Email
                <button
                  type="button"
                  onClick={copyFounderEmail}
                  className="ml-1 font-medium underline decoration-dotted text-[#334763] hover:text-[#4f9ecb]"
                  title="Copy Keith's email"
                  aria-label="Copy Keith's email"
                >
                  Keith
                </button>
                <button
                  type="button"
                  onClick={copyFounderEmail}
                  className="ml-1 inline-flex items-center justify-center align-[-2px] text-gray-500 hover:text-gray-700"
                  aria-label="Copy Keith's email"
                  title="Copy Keith's email"
                >
                  <Copy className="h-4 w-4" />
                </button>
                . He's always happy to help where he can.
              </p>
              <div className="mt-4 flex justify-center">
                <Button onClick={handleFounderClick} variant="outline" className="border-[#4f9ecb] text-[#334763]">
                  <Mail className="mr-2 h-4 w-4" /> Email Keith
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactContent;


